import { reactive } from 'vue';
import axios from 'axios';

/**
 * Estado de "wizards de onboarding vistos" por el usuario, persistido en el
 * servidor (columna users.wizards_seen). Así solo se muestran una vez por
 * usuario, entre desde donde entre, aunque cambie de navegador o borre caché.
 */
const state = reactive({ seen: [], loaded: false, loading: false });

export function loadWizards() {
  if (state.loaded || state.loading) return Promise.resolve(state.seen);
  state.loading = true;
  return axios.get('v1/users/wizards')
    .then(r => {
      state.seen = Array.isArray(r.data) ? r.data : [];
      state.loaded = true;
      state.loading = false;
      return state.seen;
    })
    .catch(() => { state.loading = false; return state.seen; });
}

export function wizardSeen(key) {
  return state.seen.includes(key);
}

export function markWizard(key) {
  if (!state.seen.includes(key)) state.seen.push(key);
  return axios.post('v1/users/wizards/' + encodeURIComponent(key)).catch(() => {});
}

export const wizardsState = state;
